import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Grid)`
  .container {
    z-index: 1;
  }
`;
